import { ProductType } from '../../type';

/** 지표 이벤트에 실리는 박스 종류 이름 */
export type BoxTypeLabel = 'default' | 'salad' | 'babybox';

// TODO: [PRD-4054] 이유식 값 'babybox'는 티켓의 이벤트 절을 따랐다. 이벤트 설계가 확정되면 다시 맞춘다.
/**
 * 박스 종류를 지표 이름으로 옮긴다.
 *
 * 세 값이 화면마다 흩어져 있으면 새 상품이 늘 때 빠뜨린 곳에서 남의 지표에 섞인다.
 */
export const BOX_TYPE_LABEL: Record<ProductType, BoxTypeLabel> = {
  [ProductType.SUBSCRIBE]: 'default',
  [ProductType.SALAD]: 'salad',
  [ProductType.BABY_FOOD]: 'babybox',
};
